import { i18n as I18n } from '../utils/i18n';

// A function rather than a constant: these urls come from translations, which
// must resolve at call time rather than at import time.
export const getExemptPages = () => [
  I18n.t('navigation.terms_and_conditions.url'),
  I18n.t('navigation.privacy_policy.url'),
];
